export default __webpack_public_path__ + "static/media/ellipse_materials.94263e8f.svg";